<section class="sbnb-onboarding">
  <sbnb-signup-header></sbnb-signup-header>

  <article class="main">
    <header>
      <h1 style="display: block; margin-bottom: 40px">You are trialling the Professional plan</h1>
    </header>

    <section
      class="content"
      [@fadeInItems]
      style="display: flex; flex-direction: row; gap: 20px; flex-wrap: wrap; justify-content: center">
      <div class="trial-item">
        <img src="/assets/images/signup/trial/trial-1.png" />
        <h3>Average of 16 hours saved per month with AI</h3>
      </div>

      <div class="trial-item">
        <img src="/assets/images/signup/trial/trial-2.png" />
        <h3>Sync your bookings, pricing, availability, and more across booking channels</h3>
      </div>

      <div class="trial-item">
        <img src="/assets/images/signup/trial/trial-3.png" />
        <h3>Average of US$178 more revenue per booking with Direct Premium</h3>
      </div>

      <div class="trial-item">
        <img src="/assets/images/signup/trial/trial-4.png" />
        <h3>Secure last-minute bookings with smart lock automation</h3>
      </div>
    </section>

    <section style="margin-top: 32px">
      <p style="font-size: 18px">
        Try out all of our features free for 14 days. Later, you can pick the plan that works best for you.
      </p>

      <span>
        <a class="strong raspberry-darker" href="https://hospitable.com/pricing#feature-comparison" target="_blank">
          Compare all features
        </a>
      </span>
    </section>

    <div style="display: flex; justify-content: end; margin-top: 24px">
      <sbnb-button (clicked)="next()">Continue</sbnb-button>
    </div>
  </article>
</section>
